import type { GuideArticle } from './articleTypes';

export const articles1: GuideArticle[] = [
  {
    slug: 'basetao-buying-guide',
    tag: { en: 'Buying Guide', fr: "Guide d'achat", de: 'Kaufanleitung', es: 'Guía de compra', pt: 'Guia de compra' },
    image:
      'https://readdy.ai/api/search-image?query=A%20tidy%20flat%20lay%20of%20a%20shopping%20cart%20a%20package%20box%20a%20credit%20card%20and%20a%20smartphone%20with%20a%20checklist%20on%20a%20warm%20cream%20desk%20surface%20soft%20natural%20light%20sage%20green%20accents%20editorial%20lifestyle%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-buying-01&orientation=landscape',
    metaTitle: {
      en: 'Basetao Buying Guide 2026: How to Order Step by Step',
      fr: "Guide d'achat Basetao 2026 : comment commander étape par étape",
      de: 'Basetao-Kaufanleitung 2026: Schritt für Schritt bestellen',
      es: 'Guía de compra Basetao 2026: cómo pedir paso a paso',
      pt: 'Guia de compra Basetao 2026: como pedir passo a passo',
    },
    metaDescription: {
      en: 'A practical Basetao buying guide covering accounts, orders, payments and tips to make your first purchase smoother and safer.',
      fr: "Un guide d'achat Basetao pratique sur les comptes, commandes, paiements et astuces pour réussir votre premier achat.",
      de: 'Eine praktische Basetao-Kaufanleitung zu Konten, Bestellungen, Zahlungen und Tipps für einen reibungsloseren ersten Einkauf.',
      es: 'Una guía de compra práctica de Basetao sobre cuentas, pedidos, pagos y consejos para que tu primera compra sea más fluida.',
      pt: 'Um guia de compra prático do Basetao sobre contas, pedidos, pagamentos e dicas para uma primeira compra mais tranquila.',
    },
    h1: {
      en: 'Basetao Buying Guide: How to Order Step by Step',
      fr: "Guide d'achat Basetao : comment commander étape par étape",
      de: 'Basetao-Kaufanleitung: Schritt für Schritt bestellen',
      es: 'Guía de compra Basetao: cómo pedir paso a paso',
      pt: 'Guia de compra Basetao: como pedir passo a passo',
    },
    eyebrow: {
      en: 'BASETAO BUYING GUIDE',
      fr: "GUIDE D'ACHAT BASETAO",
      de: 'BASETAO-KAUFANLEITUNG',
      es: 'GUÍA DE COMPRA BASETAO',
      pt: 'GUIA DE COMPRA BASETAO',
    },
    intro: {
      en: "Buying through a shipping agent can feel complicated at first, but the process is more straightforward than it looks. This guide walks through the key steps so you know what to expect before, during and after placing an order.",
      fr: "Acheter via un agent de livraison peut sembler compliqué au début, mais le processus est plus simple qu'il n'y paraît. Ce guide passe en revue les étapes clés pour savoir à quoi s'attendre avant, pendant et après une commande.",
      de: 'Der Einkauf über einen Versandagenten kann anfangs kompliziert wirken, ist aber einfacher als es aussieht. Diese Anleitung führt durch die wichtigsten Schritte, damit du weißt, was dich vor, während und nach einer Bestellung erwartet.',
      es: 'Comprar a través de un agente de envío puede parecer complicado al principio, pero el proceso es más sencillo de lo que parece. Esta guía repasa los pasos clave para que sepas qué esperar antes, durante y después de un pedido.',
      pt: 'Comprar por meio de um agente de envio pode parecer complicado no início, mas o processo é mais simples do que parece. Este guia percorre as etapas principais para você saber o que esperar antes, durante e depois de um pedido.',
    },
    sections: [
      {
        heading: {
          en: 'Create and Set Up Your Account',
          fr: 'Créez et configurez votre compte',
          de: 'Konto erstellen und einrichten',
          es: 'Crea y configura tu cuenta',
          pt: 'Crie e configure sua conta',
        },
        body: {
          en: 'Start by registering an account and confirming your email. A complete profile with your correct shipping address and contact details prevents delays later in the process, so take a minute to fill everything in accurately.',
          fr: "Commencez par créer un compte et confirmer votre e-mail. Un profil complet avec votre adresse de livraison et vos coordonnées exactes évite les retards plus tard, alors prenez une minute pour tout remplir correctement.",
          de: 'Registriere zunächst ein Konto und bestätige deine E-Mail. Ein vollständiges Profil mit korrekter Lieferadresse und Kontaktdaten verhindert spätere Verzögerungen, also nimm dir einen Moment, um alles genau auszufüllen.',
          es: 'Empieza por registrarte y confirmar tu correo. Un perfil completo con tu dirección de envío y datos de contacto correctos evita retrasos, así que tómate un minuto para rellenar todo con precisión.',
          pt: 'Comece criando uma conta e confirmando seu e-mail. Um perfil completo com endereço de entrega e contatos corretos evita atrasos, então reserve um minuto para preencher tudo com precisão.',
        },
      },
      {
        heading: {
          en: 'Find Products and Submit Links',
          fr: 'Trouvez des produits et envoyez les liens',
          de: 'Produkte finden und Links einreichen',
          es: 'Encuentra productos y envía enlaces',
          pt: 'Encontre produtos e envie links',
        },
        body: {
          en: 'Copy the link of the item you want from the marketplace and paste it into the order form. Add the size, color, quantity and any notes so the agent knows exactly what to buy for you.',
          fr: "Copiez le lien de l'article souhaité sur la place de marché et collez-le dans le formulaire de commande. Ajoutez la taille, la couleur, la quantité et toute note pour que l'agent sache exactement quoi acheter.",
          de: 'Kopiere den Link des gewünschten Artikels vom Marktplatz und füge ihn ins Bestellformular ein. Gib Größe, Farbe, Menge und Notizen an, damit der Agent genau weiß, was er für dich kaufen soll.',
          es: 'Copia el enlace del artículo en el marketplace y pégalo en el formulario de pedido. Añade la talla, el color, la cantidad y cualquier nota para que el agente sepa exactamente qué comprar.',
          pt: 'Copie o link do item no marketplace e cole no formulário de pedido. Adicione tamanho, cor, quantidade e observações para que o agente saiba exatamente o que comprar.',
        },
      },
      {
        heading: {
          en: 'Pay, Wait and Review QC Photos',
          fr: 'Payez, attendez et vérifiez les photos QC',
          de: 'Bezahlen, warten und QC-Fotos prüfen',
          es: 'Paga, espera y revisa las fotos QC',
          pt: 'Pague, aguarde e revise as fotos de QC',
        },
        body: {
          en: 'After you pay, the agent purchases the item and it arrives at their warehouse. Review the inspection photos carefully and confirm or ask for changes before the item is shipped internationally.',
          fr: "Après le paiement, l'agent achète l'article qui arrive ensuite dans son entrepôt. Examinez attentivement les photos d'inspection et confirmez ou demandez des modifications avant l'expédition internationale.",
          de: 'Nach der Zahlung kauft der Agent den Artikel, der dann in seinem Lager ankommt. Prüfe die Inspektionsfotos sorgfältig und bestätige oder fordere Änderungen an, bevor international versandt wird.',
          es: 'Tras pagar, el agente compra el artículo y este llega a su almacén. Revisa las fotos de inspección con atención y confirma o pide cambios antes del envío internacional.',
          pt: 'Após o pagamento, o agente compra o item que chega ao armazém. Revise as fotos de inspeção com atenção e confirme ou peça alterações antes do envio internacional.',
        },
      },
      {
        heading: {
          en: 'Choose Shipping and Track Delivery',
          fr: 'Choisissez la livraison et suivez le colis',
          de: 'Versand wählen und Lieferung verfolgen',
          es: 'Elige el envío y rastrea la entrega',
          pt: 'Escolha o envio e rastreie a entrega',
        },
        body: {
          en: 'Select a shipping line that fits your budget and speed needs, then submit the parcel. Keep your tracking number handy and follow the package until it reaches your door.',
          fr: "Choisissez une ligne de livraison adaptée à votre budget et à vos besoins de rapidité, puis envoyez le colis. Gardez votre numéro de suivi à portée de main jusqu'à la réception.",
          de: 'Wähle eine Versandlinie, die zu Budget und Tempo passt, und reiche das Paket ein. Behalte deine Sendungsnummer im Blick, bis das Paket ankommt.',
          es: 'Elige una línea de envío acorde a tu presupuesto y rapidez, y envía el paquete. Guarda el número de seguimiento hasta que llegue a tu puerta.',
          pt: 'Escolha uma linha de envio adequada ao seu orçamento e necessidade de rapidez, e envie o pacote. Guarde o código de rastreio até a entrega.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'Do I need an account to order?',
          fr: "Faut-il un compte pour commander ?",
          de: 'Brauche ich ein Konto zum Bestellen?',
          es: '¿Necesito una cuenta para pedir?',
          pt: 'Preciso de uma conta para pedir?',
        },
        a: {
          en: 'Yes, an account is required so the agent can manage your orders, payments and shipping in one place.',
          fr: "Oui, un compte est nécessaire pour que l'agent gère vos commandes, paiements et livraisons au même endroit.",
          de: 'Ja, ein Konto ist erforderlich, damit der Agent Bestellungen, Zahlungen und Versand zentral verwalten kann.',
          es: 'Sí, se necesita una cuenta para que el agente gestione pedidos, pagos y envíos en un solo lugar.',
          pt: 'Sim, é preciso uma conta para o agente gerenciar pedidos, pagamentos e envios em um só lugar.',
        },
      },
      {
        q: {
          en: 'Can I cancel before shipping?',
          fr: "Puis-je annuler avant l'expédition ?",
          de: 'Kann ich vor dem Versand stornieren?',
          es: '¿Puedo cancelar antes del envío?',
          pt: 'Posso cancelar antes do envio?',
        },
        a: {
          en: 'Cancellation is usually possible before the item ships, but policies vary. Contact support as early as possible for the best chance.',
          fr: "L'annulation est généralement possible avant l'expédition, mais les règles varient. Contactez le support au plus tôt.",
          de: 'Eine Stornierung ist meist vor dem Versand möglich, die Regeln variieren jedoch. Kontaktiere den Support so früh wie möglich.',
          es: 'La cancelación suele ser posible antes del envío, pero las políticas varían. Contacta al soporte lo antes posible.',
          pt: 'O cancelamento costuma ser possível antes do envio, mas as políticas variam. Entre em contato com o suporte o quanto antes.',
        },
      },
      {
        q: {
          en: 'What payment methods are supported?',
          fr: 'Quels moyens de paiement sont acceptés ?',
          de: 'Welche Zahlungsmethoden werden unterstützt?',
          es: '¿Qué métodos de pago se aceptan?',
          pt: 'Quais formas de pagamento são aceitas?',
        },
        a: {
          en: 'Supported methods change over time and by region, so check the current options shown at checkout before you commit.',
          fr: "Les méthodes acceptées évoluent selon la région, vérifiez donc les options affichées au paiement avant de valider.",
          de: 'Die unterstützten Methoden ändern sich je nach Region, prüfe daher die Optionen an der Kasse vor dem Abschluss.',
          es: 'Los métodos cambian según la región, así que revisa las opciones en el pago antes de confirmar.',
          pt: 'Os métodos mudam conforme a região, então verifique as opções no checkout antes de confirmar.',
        },
      },
    ],
  },
  {
    slug: 'basetao-review',
    tag: { en: 'Review', fr: 'Avis', de: 'Test', es: 'Reseña', pt: 'Avaliação' },
    image:
      'https://readdy.ai/api/search-image?query=A%20clean%20desk%20scene%20with%20a%20five%20star%20rating%20card%20a%20notepad%20and%20a%20cup%20of%20coffee%20next%20to%20a%20laptop%20on%20a%20warm%20cream%20background%20soft%20natural%20light%20sage%20green%20accents%20editorial%20lifestyle%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-review-01&orientation=landscape',
    metaTitle: {
      en: 'Basetao Review 2026: Features, Pros & Cons',
      fr: 'Avis Basetao 2026 : fonctionnalités, avantages et inconvénients',
      de: 'Basetao Test 2026: Funktionen, Vor- und Nachteile',
      es: 'Reseña de Basetao 2026: funciones, pros y contras',
      pt: 'Avaliação do Basetao 2026: recursos, prós e contras',
    },
    metaDescription: {
      en: 'An honest Basetao review covering what the service does, its main features, strengths and limitations to help you decide if it fits your needs.',
      fr: "Un avis honnête sur Basetao : ce que fait le service, ses fonctions principales, ses forces et limites pour vous aider à décider.",
      de: 'Ein ehrlicher Basetao-Test zu Funktionen, Stärken und Grenzen des Dienstes, um dir bei der Entscheidung zu helfen.',
      es: 'Una reseña honesta de Basetao sobre sus funciones, ventajas y limitaciones para ayudarte a decidir si te conviene.',
      pt: 'Uma avaliação honesta do Basetao sobre funções, vantagens e limitações para você decidir se ele atende às suas necessidades.',
    },
    h1: {
      en: 'Basetao Review 2026: Features, Pros & Cons',
      fr: 'Avis Basetao 2026 : fonctionnalités, avantages et inconvénients',
      de: 'Basetao Test 2026: Funktionen, Vor- und Nachteile',
      es: 'Reseña de Basetao 2026: funciones, pros y contras',
      pt: 'Avaliação do Basetao 2026: recursos, prós e contras',
    },
    eyebrow: {
      en: 'BASETAO REVIEW',
      fr: 'AVIS BASETAO',
      de: 'BASETAO TEST',
      es: 'RESEÑA DE BASETAO',
      pt: 'AVALIAÇÃO DO BASETAO',
    },
    intro: {
      en: 'Basetao is a shopping agent that helps international buyers purchase from Chinese marketplaces and ship items to their home country. This review explains what it does, how it works and what to watch out for.',
      fr: "Basetao est un agent d'achat qui aide les acheteurs internationaux à commander sur les places de marché chinoises et à se faire livrer. Cet avis explique ce qu'il fait, comment il fonctionne et les points de vigilance.",
      de: 'Basetao ist ein Shopping-Agent, der internationalen Käufern hilft, auf chinesischen Marktplätzen einzukaufen und Waren nach Hause liefern zu lassen. Dieser Test erklärt Funktionen und worauf zu achten ist.',
      es: 'Basetao es un agente de compras que ayuda a compradores internacionales a comprar en marketplaces chinos y recibir los artículos en su país. Esta reseña explica qué hace y en qué fijarse.',
      pt: 'O Basetao é um agente de compras que ajuda compradores internacionais a comprar em marketplaces chineses e receber os itens em casa. Esta avaliação explica o que ele faz e no que ficar atento.',
    },
    sections: [
      {
        heading: {
          en: 'What Basetao Does',
          fr: 'Ce que fait Basetao',
          de: 'Was Basetao macht',
          es: 'Qué hace Basetao',
          pt: 'O que o Basetao faz',
        },
        body: {
          en: 'The service acts as a middle layer between you and local sellers. It purchases the items you choose, stores them in a warehouse, takes inspection photos and then forwards the package to your international address.',
          fr: "Le service sert d'intermédiaire entre vous et les vendeurs locaux. Il achète les articles choisis, les stocke, prend des photos d'inspection puis expédie le colis à votre adresse internationale.",
          de: 'Der Dienst fungiert als Zwischenschicht zwischen dir und lokalen Verkäufern. Er kauft die gewählten Artikel, lagert sie, macht Inspektionsfotos und versendet das Paket an deine internationale Adresse.',
          es: 'El servicio actúa como intermediario entre tú y los vendedores. Compra los artículos, los almacena, toma fotos de inspección y envía el paquete a tu dirección internacional.',
          pt: 'O serviço atua como intermediário entre você e os vendedores. Ele compra os itens, armazena, tira fotos de inspeção e envia o pacote ao seu endereço internacional.',
        },
      },
      {
        heading: {
          en: 'Main Strengths',
          fr: 'Principaux atouts',
          de: 'Hauptstärken',
          es: 'Principales ventajas',
          pt: 'Principais pontos fortes',
        },
        body: {
          en: 'Buyers often highlight the convenience of consolidated shipping, the inspection photos and the ability to buy from many sellers in a single order. These features make it easier to manage a multi-item purchase.',
          fr: "Les acheteurs soulignent la commodité de l'envoi consolidé, les photos d'inspection et la possibilité d'acheter auprès de nombreux vendeurs en une seule commande.",
          de: 'Käufer heben den bequemen Sammelversand, die Inspektionsfotos und die Möglichkeit hervor, bei vielen Verkäufern in einer Bestellung einzukaufen.',
          es: 'Los compradores destacan la comodidad del envío consolidado, las fotos de inspección y la posibilidad de comprar a varios vendedores en un solo pedido.',
          pt: 'Os compradores destacam a comodidade do envio consolidado, as fotos de inspeção e a possibilidade de comprar de vários vendedores em um só pedido.',
        },
      },
      {
        heading: {
          en: 'Potential Limitations',
          fr: 'Limites éventuelles',
          de: 'Mögliche Einschränkungen',
          es: 'Posibles limitaciones',
          pt: 'Possíveis limitações',
        },
        body: {
          en: 'Fees, shipping costs and exchange rates can add up, and international delivery always carries some risk. Understanding the total cost before ordering helps you avoid surprises.',
          fr: "Les frais, les coûts d'expédition et les taux de change peuvent s'additionner, et la livraison internationale comporte toujours un risque. Comprendre le coût total avant de commander évite les surprises.",
          de: 'Gebühren, Versandkosten und Wechselkurse können sich summieren, und internationaler Versand birgt immer ein Risiko. Die Gesamtkosten vorab zu verstehen, vermeidet Überraschungen.',
          es: 'Las tarifas, los costes de envío y el tipo de cambio pueden sumar, y el envío internacional siempre implica riesgo. Entender el coste total evita sorpresas.',
          pt: 'Taxas, custos de envio e câmbio podem se acumular, e o envio internacional sempre envolve risco. Entender o custo total evita surpresas.',
        },
      },
      {
        heading: {
          en: 'Who It Is Best For',
          fr: "À qui cela s'adresse-t-il ?",
          de: 'Für wen es sich am besten eignet',
          es: 'Para quién es más adecuado',
          pt: 'Para quem é mais indicado',
        },
        body: {
          en: 'Basetao is best for buyers who want items from Chinese marketplaces without handling each seller individually, especially when buying multiple products that can be shipped together.',
          fr: "Basetao convient surtout aux acheteurs qui veulent des articles des places de marché chinoises sans gérer chaque vendeur séparément, surtout pour des achats multiples groupés.",
          de: 'Basetao eignet sich am besten für Käufer, die Artikel von chinesischen Marktplätzen möchten, ohne jeden Verkäufer einzeln zu verwalten, besonders bei Mehrfachkäufen.',
          es: 'Basetao es ideal para quienes quieren artículos de marketplaces chinos sin gestionar a cada vendedor por separado, sobre todo al comprar varios productos que se envían juntos.',
          pt: 'O Basetao é ideal para quem quer itens de marketplaces chineses sem gerenciar cada vendedor, especialmente ao comprar vários produtos enviados juntos.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'Is Basetao a marketplace?',
          fr: 'Basetao est-il une place de marché ?',
          de: 'Ist Basetao ein Marktplatz?',
          es: '¿Basetao es un marketplace?',
          pt: 'O Basetao é um marketplace?',
        },
        a: {
          en: 'No, it is a buying agent. It purchases from marketplaces on your behalf rather than selling products directly.',
          fr: "Non, c'est un agent d'achat qui commande pour vous sur les places de marché au lieu de vendre directement.",
          de: 'Nein, es ist ein Einkaufsagent, der in deinem Namen auf Marktplätzen kauft, statt Produkte direkt zu verkaufen.',
          es: 'No, es un agente de compras que compra en tu nombre en vez de vender productos directamente.',
          pt: 'Não, é um agente de compras que compra por você em vez de vender produtos diretamente.',
        },
      },
      {
        q: {
          en: 'Are there hidden fees?',
          fr: 'Y a-t-il des frais cachés ?',
          de: 'Gibt es versteckte Gebühren?',
          es: '¿Hay tarifas ocultas?',
          pt: 'Há taxas ocultas?',
        },
        a: {
          en: 'Fees are usually shown during checkout, but shipping, service and currency fees can vary. Review the breakdown before paying.',
          fr: "Les frais sont généralement affichés au paiement, mais les frais d'expédition, de service et de change varient. Vérifiez le détail avant de payer.",
          de: 'Gebühren werden meist an der Kasse angezeigt, können aber variieren. Prüfe die Aufschlüsselung vor der Zahlung.',
          es: 'Las tarifas suelen mostrarse al pagar, pero pueden variar. Revisa el desglose antes de pagar.',
          pt: 'As taxas costumam aparecer no checkout, mas podem variar. Revise o detalhamento antes de pagar.',
        },
      },
      {
        q: {
          en: 'Can I ship to any country?',
          fr: 'Puis-je me faire livrer dans n’importe quel pays ?',
          de: 'Kann ich in jedes Land versenden?',
          es: '¿Puedo recibir en cualquier país?',
          pt: 'Posso receber em qualquer país?',
        },
        a: {
          en: 'Most international destinations are supported, but availability depends on the shipping lines offered. Check your country during checkout.',
          fr: "La plupart des destinations sont prises en charge, mais cela dépend des lignes proposées. Vérifiez votre pays au paiement.",
          de: 'Die meisten Ziele werden unterstützt, hängt aber von den angebotenen Linien ab. Prüfe dein Land an der Kasse.',
          es: 'La mayoría de destinos están cubiertos, pero depende de las líneas. Verifica tu país al pagar.',
          pt: 'A maioria dos destinos é suportada, mas depende das linhas. Verifique seu país no checkout.',
        },
      },
    ],
  },
  {
    slug: 'basetao-shipping-cost',
    tag: { en: 'Shipping', fr: 'Livraison', de: 'Versand', es: 'Envío', pt: 'Envio' },
    image:
      'https://readdy.ai/api/search-image?query=A%20stack%20of%20cardboard%20shipping%20boxes%20with%20a%20measuring%20tape%20and%20a%20small%20label%20on%20a%20warm%20cream%20table%20soft%20natural%20light%20sage%20green%20accents%20editorial%20still%20life%20photography%20high%20detail%20airy%20fresh%20aesthetic&width=800&height=600&seq=art-shipping-01&orientation=landscape',
    metaTitle: {
      en: 'Basetao Shipping Cost: Complete Guide to Prices & Options',
      fr: 'Coût de livraison Basetao : guide complet des prix et options',
      de: 'Basetao Versandkosten: kompletter Leitfaden zu Preisen und Optionen',
      es: 'Coste de envío Basetao: guía completa de precios y opciones',
      pt: 'Custo de envio Basetao: guia completo de preços e opções',
    },
    metaDescription: {
      en: 'Learn how Basetao shipping costs are calculated, the main methods available, and practical tips to reduce your international delivery bill.',
      fr: "Découvrez comment les coûts de livraison Basetao sont calculés, les méthodes disponibles et des astuces pour réduire votre facture.",
      de: 'Erfahre, wie Basetao-Versandkosten berechnet werden, welche Methoden es gibt und wie du deine internationale Versandrechnung senkst.',
      es: 'Descubre cómo se calculan los costes de envío de Basetao, los métodos disponibles y consejos para reducir tu factura.',
      pt: 'Saiba como os custos de envio do Basetao são calculados, os métodos disponíveis e dicas para reduzir sua conta de envio.',
    },
    h1: {
      en: 'Basetao Shipping Cost: Complete Guide to Prices & Options',
      fr: 'Coût de livraison Basetao : guide complet des prix et options',
      de: 'Basetao Versandkosten: kompletter Leitfaden',
      es: 'Coste de envío Basetao: guía completa',
      pt: 'Custo de envio Basetao: guia completo',
    },
    eyebrow: {
      en: 'BASETAO SHIPPING COST',
      fr: 'COÛT DE LIVRAISON BASETAO',
      de: 'BASETAO VERSANDKOSTEN',
      es: 'COSTE DE ENVÍO BASETAO',
      pt: 'CUSTO DE ENVIO BASETAO',
    },
    intro: {
      en: 'Shipping is often the biggest variable in the total cost of an international order. Understanding how prices are calculated and which methods exist can help you save money and pick the right balance between speed and cost.',
      fr: "La livraison est souvent la plus grande variable du coût total d'une commande internationale. Comprendre le calcul des prix et les méthodes disponibles aide à économiser.",
      de: 'Der Versand ist oft der größte variable Posten einer internationalen Bestellung. Wer Preise und Methoden versteht, kann sparen und die richtige Balance zwischen Tempo und Kosten wählen.',
      es: 'El envío suele ser la mayor variable del coste total de un pedido internacional. Entender cómo se calcula y qué métodos existen ayuda a ahorrar.',
      pt: 'O envio costuma ser a maior variável no custo total de um pedido internacional. Entender o cálculo e os métodos ajuda a economizar.',
    },
    sections: [
      {
        heading: {
          en: 'How Shipping Cost Is Calculated',
          fr: 'Comment le coût de livraison est calculé',
          de: 'Wie Versandkosten berechnet werden',
          es: 'Cómo se calcula el coste de envío',
          pt: 'Como o custo de envio é calculado',
        },
        body: {
          en: 'Cost is typically based on the actual or volumetric weight of your parcel and the shipping line you choose. Heavier, larger packages and faster lines usually cost more.',
          fr: "Le coût dépend généralement du poids réel ou volumétrique du colis et de la ligne choisie. Les colis plus lourds, plus grands et les lignes rapides coûtent plus cher.",
          de: 'Die Kosten richten sich meist nach dem tatsächlichen oder Volumengewicht des Pakets und der gewählten Linie. Schwerere, größere Pakete und schnellere Linien kosten mehr.',
          es: 'El coste se basa en el peso real o volumétrico del paquete y la línea elegida. Los paquetes más pesados y las líneas rápidas cuestan más.',
          pt: 'O custo geralmente se baseia no peso real ou volumétrico e na linha escolhida. Pacotes mais pesados e linhas rápidas custam mais.',
        },
      },
      {
        heading: {
          en: 'Common Shipping Methods',
          fr: 'Méthodes de livraison courantes',
          de: 'Gängige Versandmethoden',
          es: 'Métodos de envío comunes',
          pt: 'Métodos de envio comuns',
        },
        body: {
          en: 'Options often range from slower, budget-friendly lines to faster express couriers. Economy lines save money, while express services prioritize speed and tracking.',
          fr: "Les options vont des lignes économiques lentes aux transporteurs express rapides. Les lignes économiques font économiser, tandis que l'express privilégie vitesse et suivi.",
          de: 'Die Optionen reichen von langsamen, günstigen Linien bis zu schnellen Expresskurieren. Sparlinien sparen Geld, Expressdienste setzen auf Tempo und Tracking.',
          es: 'Las opciones van de líneas económicas lentas a mensajería exprés. Las económicas ahorran; las exprés priorizan rapidez y seguimiento.',
          pt: 'As opções vão de linhas econômicas lentas a serviços expressos. As econômicas poupam; as expressas priorizam rapidez e rastreio.',
        },
      },
      {
        heading: {
          en: 'Tips to Lower Shipping Cost',
          fr: 'Astuces pour réduire le coût',
          de: 'Tipps zum Senken der Versandkosten',
          es: 'Consejos para reducir el coste',
          pt: 'Dicas para reduzir o custo',
        },
        body: {
          en: 'Consolidate several items into one parcel, avoid bulky packaging and compare lines before submitting. Small choices like these can noticeably reduce the final bill.',
          fr: "Regroupez plusieurs articles en un colis, évitez les emballages volumineux et comparez les lignes avant d'envoyer. Ces petits choix réduisent nettement la facture.",
          de: 'Fasse mehrere Artikel zu einem Paket zusammen, vermeide sperrige Verpackungen und vergleiche Linien vor dem Versand. Das senkt die Rechnung spürbar.',
          es: 'Consolida varios artículos en un paquete, evita embalajes voluminosos y compara líneas. Esto reduce notablemente la factura.',
          pt: 'Consolide vários itens em um pacote, evite embalagens volumosas e compare as linhas. Isso reduz claramente a conta.',
        },
      },
      {
        heading: {
          en: 'Understanding Time Estimates',
          fr: 'Comprendre les délais estimés',
          de: 'Lieferzeiten verstehen',
          es: 'Entender las estimaciones de tiempo',
          pt: 'Entender as estimativas de prazo',
        },
        body: {
          en: 'Delivery times are estimates and can be affected by customs, holidays and weather. Build in a little buffer when you need an item by a specific date.',
          fr: "Les délais sont des estimations et peuvent être affectés par la douane, les jours fériés et la météo. Prévoyez une marge si vous avez besoin d'un article à une date précise.",
          de: 'Lieferzeiten sind Schätzungen und können durch Zoll, Feiertage und Wetter beeinflusst werden. Plane Puffer ein, wenn du einen Artikel zu einem Termin brauchst.',
          es: 'Los plazos son estimaciones y pueden verse afectados por aduanas, festivos y clima. Añade margen si necesitas un artículo para una fecha concreta.',
          pt: 'Os prazos são estimativas e podem ser afetados por alfândega, feriados e clima. Deixe uma margem se precisar de um item para uma data.',
        },
      },
    ],
    faqs: [
      {
        q: {
          en: 'What is volumetric weight?',
          fr: "Qu'est-ce que le poids volumétrique ?",
          de: 'Was ist Volumengewicht?',
          es: '¿Qué es el peso volumétrico?',
          pt: 'O que é peso volumétrico?',
        },
        a: {
          en: 'It is a calculation based on package size rather than actual weight, used when a parcel is large but light.',
          fr: "C'est un calcul basé sur la taille du colis plutôt que son poids réel, utilisé pour les colis grands mais légers.",
          de: 'Eine Berechnung auf Basis der Paketgröße statt des tatsächlichen Gewichts, genutzt bei großen, leichten Paketen.',
          es: 'Un cálculo basado en el tamaño del paquete y no en el peso real, usado en paquetes grandes y ligeros.',
          pt: 'Um cálculo baseado no tamanho do pacote em vez do peso real, usado em pacotes grandes e leves.',
        },
      },
      {
        q: {
          en: 'Can I get a shipping quote in advance?',
          fr: "Puis-je obtenir un devis à l'avance ?",
          de: 'Kann ich vorab einen Versandpreis erhalten?',
          es: '¿Puedo obtener una cotización por adelantado?',
          pt: 'Posso obter uma cotação antecipada?',
        },
        a: {
          en: 'Many platforms offer a shipping calculator or estimate before checkout, though the final price is confirmed once the parcel is weighed.',
          fr: "De nombreuses plateformes offrent un calculateur ou une estimation avant le paiement, le prix final étant confirmé après pesée.",
          de: 'Viele Plattformen bieten einen Rechner oder eine Schätzung vor dem Checkout; der Endpreis wird nach dem Wiegen bestätigt.',
          es: 'Muchas plataformas ofrecen calculadora o estimación antes de pagar; el precio final se confirma al pesar.',
          pt: 'Muitas plataformas oferecem calculadora ou estimativa antes do checkout; o preço final é confirmado após a pesagem.',
        },
      },
      {
        q: {
          en: 'Which is cheaper, air or sea?',
          fr: 'Quoi de moins cher, avion ou bateau ?',
          de: 'Was ist günstiger, Luft oder See?',
          es: '¿Qué es más barato, aéreo o marítimo?',
          pt: 'O que é mais barato, aéreo ou marítimo?',
        },
        a: {
          en: 'Sea freight is generally cheaper but much slower, while air is faster and more expensive. Your choice depends on budget and urgency.',
          fr: "Le fret maritime est généralement moins cher mais plus lent, tandis que l'avion est plus rapide et plus coûteux. Votre choix dépend du budget et de l'urgence.",
          de: 'Seefracht ist meist günstiger, aber deutlich langsamer, Luftfracht schneller und teurer. Die Wahl hängt von Budget und Dringlichkeit ab.',
          es: 'El marítimo suele ser más barato pero más lento; el aéreo es más rápido y caro. Depende de tu presupuesto y urgencia.',
          pt: 'O marítimo costuma ser mais barato porém mais lento; o aéreo é mais rápido e caro. Depende de orçamento e urgência.',
        },
      },
    ],
  },
];